<template>
    <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
      <div class="toolbar" id="kt_toolbar">
        <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
          <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
            <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
            <span class="h-20px border-gray-300 border-start mx-4"></span>
            <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <div v-for="(bread, key) in breadcrumbs" :key="key">
                <div>
                  <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumbs.length">
                    <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                  </li>
                  <li class="breadcrumb-item" v-if="key + 1 !== breadcrumbs.length">
                    <span class="bullet bg-gray-300 w-5px h-2px"></span>
                  </li>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
  
      <div class="post d-flex flex-column-fluid" id="kt_post">
        <div v-show="isReady" id="kt_content_container" class="container-xxl">
          <div class="card mb-6">
            <div class="card-body pt-9 pb-0">
              <div class="d-flex flex-wrap flex-sm-nowrap">
                <div class="me-7 mb-4 pt-6 m-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z"
                      fill="currentColor" />
                    <path opacity="0.3"
                      d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z"
                      fill="#3f4254" />
                  </svg>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                    <div class="d-flex flex-column">
                   
                      <div class="d-flex align-items-center mb-2">
                        <span class="text-gray-900 fs-2 fw-bolder me-1">
                          {{ detailInformation?.society }}</span>
                      </div>
                      <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                        <span class="d-flex align-items-center text-gray-400 me-5 mb-2">
                          <span class="svg-icon svg-icon-4 me-1 text-black">
                            
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path opacity="0.3"
                                d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                                fill="currentColor"></path>
                              <path
                                d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                                fill="currentColor"></path>
                            </svg>
                          </span>
                          {{ detailInformation?.address }}</span>
                        <span class="d-flex align-items-center text-gray-400 mb-2">
                          <span class="svg-icon svg-icon-4 me-1 text-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path opacity="0.3"
                                d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                                fill="currentColor"></path>
                              <path
                                d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                                fill="currentColor"></path>
                            </svg>
                          </span>
                          {{ detailInformation?.society_email }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap flex-stack">
                    <div class="d-flex flex-column flex-grow-1 pe-8">
                      <div class="d-flex flex-wrap">
                        
                        <router-link v-if="$can('product_view')" to="/admin/settings-product" class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div class="fw-bold fs-6 text-gray-400">{{ $t('information.product') }}</div>
                          <div class="d-flex align-items-center">
                            <div class="fs-2 fw-bolder counted" data-kt-countup="true">{{ informations.totalProduct }}</div>
                          </div>
                        </router-link>
                        <router-link  v-if="$can('boutique_view')" to="/admin/shops" class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div class="fw-bold fs-6 text-gray-400">{{ $t('information.shop') }}</div>
                          <div class="d-flex align-items-center">
                            <i class="fas fa-store fs-3 text-center text-primary text-sm-center me-2"></i>
                            <div class="fs-2 fw-bolder counted me-4" data-kt-countup="true">{{ informations.totalShopActive }}</div>
                            <i class="fas fa-store fs-3 text-center text-danger text-sm-center me-2"></i>
                            <div class="fs-2 fw-bolder counted text-danger" data-kt-countup="true">{{ informations.totalShopUnactive }}</div>
                            <div>
                            </div>
                          </div>
                        </router-link>
                        <router-link v-if="$can('magasin_view')" to="/admin/stores" class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div class="fw-bold fs-6 text-gray-400">{{ $t('information.store') }}</div>
                          <div class="d-flex align-items-center">
                            <i class="fas fa-store fs-3 text-center text-primary text-sm-center me-2"></i>
                            <div class="fs-2 fw-bolder counted me-4" data-kt-countup="true">{{ informations.totalStoreActive }}</div>
                            <i class="fas fa-store fs-3 text-center text-danger text-sm-center me-2"></i>
                            <div class="fs-2 fw-bolder counted text-danger" data-kt-countup="true">{{ informations.totalStoreUnactive }}</div>
                          </div>
                        </router-link>
                        <router-link  v-if="$can('customer_view')" to="/admin/contacts" class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div class="fw-bold fs-6 text-gray-400">{{ $t('information.customer') }}</div>
                          <div class="d-flex align-items-center">
                            <div class="fs-2 fw-bolder counted" data-kt-countup="true">{{ informations.totalCustomer }}
                            </div>
                          </div>
                        </router-link>
                        <router-link  v-if="$can('users_view')" to="/admin/settings-user" class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div class="fw-bold fs-6 text-gray-400">{{ $t('information.employe') }}</div>
                          <div class="d-flex align-items-center">
                            <div class="fs-2 fw-bolder counted" data-kt-countup="true">{{ informations.totalEmploye }}</div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
                <a class="nav-item mt-2">
                  <span class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(1)"
                    :class="section == 1 ? 'active' : ''">{{ $t('auth.general_society') }}</span>
                </a>
                <a class="nav-item mt-2">
                  <span class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(2)"
                    :class="section == 2 ? 'active' : ''">{{ $t('auth.responsable') }}</span>
                </a>
                <a href="#iframe_document" data-kt-scroll-toggle class="nav-item mt-2">
                  <span class="cursor-pointer nav-link text-active-primary ms-0 me-10 py-5" @click="changeSection(3)"
                    :class="section == 3 ? 'active' : ''">{{ $t('auth.document') }}</span>
                </a>
              </ul>
            </div>
          </div>
          <div class="card" v-show="section == 1">
            <div class="card card-flush pt-3 mb-5 mb-lg-10" data-kt-subscriptions-form="pricing">
              <div class="fs-6 ps-10 d-flex flex-wrap py-5">
                <div class="flex-equal me-5">
                  <div class="d-flex flex-wrap py-5">
                    <div class="flex-equal me-5">
                      <table class="table fs-6 fw-bold gs-0 gy-2 gx-2 m-0">
                        <tbody>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.name_society') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.society }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.society_email') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.society_email }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.society_phone') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.society_phone}}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.country') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.country_id ?
                                informations.infoGeneral?.country.name + '(' + informations.infoGeneral?.country.iso_alpha2
                                + ')' : '' }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.city') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.city ?
                                detailInformation?.city : '' }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.address') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.address ?
                                detailInformation?.address : '' }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('delivery.currency') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.country_id ?
                                informations.infoGeneral?.country.currency_name + '(' + informations.infoGeneral?.country.currency_symbol+ ')' : '' }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="flex-equal">
                  <div class="d-flex flex-wrap py-5">
                    <div class="flex-equal me-5">
                      <table class="table fs-6 fw-bold gs-0 gy-2 gx-2 m-0">
                        <tbody>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.domain') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.backoffice_url ? detailInformation?.backoffice_url : '' }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.website') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.website ? detailInformation?.website : '' }}</td>
                          </tr>
                          <tr>
                            <td class="text-gray-400 min-w-175px w-175px">{{ $t('auth.matricule_number') }}</td>
                            <td class="text-gray-800 min-w-200px">
                              <span class="text-gray-800 text-hover-primary">{{ detailInformation?.ifu_number ?
                                detailInformation?.ifu_number : '' }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.rccm_number') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.rccm_number ? detailInformation?.rccm_number :
                              '' }}</td>
                          </tr>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.tva_number') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.tva_number ? detailInformation?.tva_number :
                              '' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" v-show="section == 2">
            <div class="card card-flush pt-3 mb-5 mb-lg-10" data-kt-subscriptions-form="pricing">
              <div class="fs-6 ps-10 d-flex flex-wrap py-5">
                <div class="flex-equal me-5">
                  <div class="d-flex flex-wrap py-5">
                    <div class="flex-equal me-5">
                      <table class="table fs-6 fw-bold gs-0 gy-2 gx-2 m-0">
                        <tbody>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.responsable_lastname') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.responsable_lastname ?
                              detailInformation?.responsable_lastname : '' }}</td>
                          </tr>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.responsable_firstname') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.responsable_firstname ?
                                detailInformation?.responsable_firstname : '' }}</td>
                          </tr>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.responsable_email') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.responsable_email ?
                              detailInformation?.responsable_email : '' }}</td>
                          </tr>
                          <tr>
                            <td class="text-gray-400">{{ $t('auth.responsable_phone') }}</td>
                            <td class="text-gray-800">{{ detailInformation?.responsable_phone ?
                              detailInformation?.responsable_phone : '' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" v-show="section == 3">
            <div id="iframe_document" data-kt-scroll-offset="85" class="row py-5 ps-10 pe-10">
              <div class="col-sm-4">
                <input type="radio" class="btn-check" v-model="file_select" name="radio_buttons_2" value="ifu_file_url" id="kt_radio_buttons_2_option_1"/>
                <a href="#iframe_document" data-kt-scroll-toggle @click="previewDocument('ifu_file_url')" class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-5" for="kt_radio_buttons_2_option_1">
                    <span class="d-block fw-bold text-start">
                        <span class="text-dark fw-bolder d-block fs-3">{{ $t('auth.matricule_number') }}</span>
                        <span class="text-muted fw-bold fs-6">
                            {{ detailInformation?.ifu_number }}
                        </span>
                    </span>
                </a>
              </div>
              <div class="col-sm-4">
                <input type="radio" class="btn-check" v-model="file_select" name="radio_buttons_2" value="rccm_file_url"  id="kt_radio_buttons_2_option_2"/>
                <a href="#iframe_document" data-kt-scroll-toggle @click="previewDocument('rccm_file_url')" class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-5" for="kt_radio_buttons_2_option_2">
                    <span class="d-block fw-bold text-start">
                        <span class="text-dark fw-bolder d-block fs-3">{{ $t('auth.rccm_number') }}</span>
                        <span class="text-muted fw-bold fs-6">
                            {{ detailInformation?.rccm_number }}
                        </span>
                    </span>
                </a>
              </div>
              <div class="col-sm-4">
                <input type="radio" class="btn-check" v-model="file_select" name="radio_buttons_2" value="address_file_url" id="kt_radio_buttons_2_option_3"/>
                <a href="#iframe_document" data-kt-scroll-toggle @click="previewDocument('address_file_url')" class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" for="kt_radio_buttons_2_option_3">
                    <span class="d-block fw-bold text-start">
                        <span class="text-dark fw-bolder d-block fs-3">{{ $t('auth.address') }}</span>
                        <span class="text-muted fw-bold fs-6">
                          {{ detailInformation?.address }}
                        </span>
                    </span>
                </a>
              </div>
            </div>
            <div v-show="documentFound" class="card py-5 ps-10 pe-10">
              <div class="row gx-9 gy-6">
                <div class="col-sm-9"></div>
                <div class="col-sm-3 text-end">
                  <button class="btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger" @click="closePreview">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-excel" viewBox="0 0 16 16">
                      <path d="M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z"/>
                    </svg>
                  </button>
                </div>
                <iframe :src="previewUrl" width="100%" height="600px"></iframe>
              </div>
            </div>
            <div v-show="!documentFound" class="card py-5 ps-10 pe-10">
              <div class="row gx-9 gy-6">
                <div class="text-center card mb-4">
                  <span v-show="!closeFile" class="text-danger fs-2">Le document n'a pas été trouvé.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-xxl" v-show="!isReady">
        <Loader />
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import 'intro.js/introjs.css';
  import { nextTick } from 'vue';
  import Loader from "@/components/Loader.vue";
  export default {

    components: { Loader },

    data() {
      return {
        title: "navigation.general_path",
        section: 1,
        breadcrumbs: [
          {
            name: 'navigation.general_path',
            path: '/admin'
          },
        ],
        informations: [],
        detailInformation: [],
        documents: [],
        previewUrl: '',
        isReady: false,
        closeFile: false,
        documentFound: false,
        file_select: 'ifu_file_url'
      }
    },
  
  
    async mounted() {
      this.isReady = false
      await this.getGeneralInformation().finally(() =>  this.isReady = true )
    },
  
    methods: {
      ...mapActions('shop', ['generalInformation']),
      async getGeneralInformation() {
        let response = await this.generalInformation()
        this.informations = response.data
        this.detailInformation = response?.data?.infoGeneral.tenant_information
        this.documents = response.data.infoGeneral.documents
        this.previewDocument(this.file_select)
      },
      changeSection(number) {
        this.section = number
      },
      previewDocument(documentKey) {
      this.closeFile = false;
        const documentSelect = this.documents[documentKey];
        if (documentSelect) {
          this.previewUrl = documentSelect.url;
          this.file_select = documentKey;
          if((documentSelect.url == null) || (documentSelect.url == 'null')){
            this.documentFound = false;
          }else{
            this.documentFound = true;
          }
        } else {
          this.documentFound = false;
        }
      },
      closePreview() {
        this.previewUrl = '';
        this.file_select = null
        this.documentFound = false;
        this.closeFile = true;
      },
    }
  }
  </script>
  
  <style>.custom-tooltip-class {
    background-color: #fff;
    border: 2px solid #000;
    color: #000;
    font-size: 13px;
    border-radius: 5px;
    width: 1500px;
  }</style>
  